import * as React from "react";
import {cx} from "emotion";

import {scope} from "@common/react/scope";
import {FilterOptions} from "./options/filter-options";
import {ConfirmLeaveDialog} from "./confirm-leave-dialog/confirm-leave-dialog";
import {ConfigFieldOverride} from "../../../../../collection/common/filters/filter-left-panel/config-field-override";
import {SuspendUpdate} from "@common/react/suspend-update";
import {AggregationFieldSelect, FieldSelect} from "../../../../../collection/common/filters/filter-left-panel/field-select";
import {equalDeep} from "@common/utils/objects";
import {ffToTextInput} from "../../../../../../../../common/form/ff-to-text-input";
import {TextInput} from "../../../../../../../../common/form/text-input/text-input";
import {Form2} from "@common/react/cs-form/form2";
import {NumberAggregationFunctionSelect} from "../../../../../collection/common/number-aggregation-function-select/number-aggregation-function-select";
import {LeftPanelClosable} from "../../../../../common/left-panel-closable/left-panel-closable";
import {UseState} from "@common/react/use-state";
import {SelectFilterType} from "../../../../../collection/common/filters/filter-left-panel/select-filter-type";
import {Expandable} from "../../../../../common/expandable/expandable";
import {cs} from "@common/react/chain-services";
import {filterFormConfig} from "./filter-form-config";
import {contextualFilterDefaultValues} from "./contextual-filter-default-values";
import {Button} from "../../../../../../../../common/form/buttons/button/button";

export const EditFilter = ({initFilter, onCancel, onDone, onDelete, tileType}) =>
    cs(
        ["initFilterState", (_, next) => UseState({initValue: initFilter, next})],
        ["confirmLeaveDialog", (_, next) => ConfirmLeaveDialog({next})],
        ["filter", (_, next) => UseState({initValue: initFilter, next})],
        ["editFieldOverride", (_, next) => UseState({next})],
        [
            "form",
            ({filter, initFilterState}, next) =>
                Form2({
                    data: filter,
                    ...filterFormConfig,
                    onSubmit: async (isClose) => {
                        initFilterState.onChange(filter.value);
                        await onDone(filter.value);
                        if (isClose) onCancel();
                    },
                    next,
                }),
        ],

        ({confirmLeaveDialog, filter, form, initFilterState}, next) => (
            <LeftPanelClosable
                {...{
                    onClose: async () => {
                        if (filter.value === initFilterState.value) {
                            onCancel();
                            return;
                        }
                        const answer = await confirmLeaveDialog.show();
                        if (answer === "save") {
                            form.submit(true);
                        } else if (answer === "discard") {
                            onCancel();
                        } else {
                        }
                    },
                    label: `${initFilter ? "Edit" : "Add"} Tile Filter`,
                    content: next(),
                }}
            />
        ),
        ({filter, form, initFilterState, editFieldOverride, confirmLeaveDialog}) => (
            <div className="edit-local-filter-2cd">
                {Expandable({
                    label: "Type",
                    render: () => (
                        <div className="type-52w">
                            {SelectFilterType({
                                filter: filter.value,
                                onChange: (type) => filter.onChange(contextualFilterDefaultValues(type)),
                            })}

                            {filter.value && (
                                <>
                                    {FieldSelect({
                                        filter,
                                        field: form.field(["columns"]),
                                    })}

                                    {filter.value.$type === "NumericFilter" && (
                                        <>
                                            {NumberAggregationFunctionSelect({
                                                state: scope(filter, ["aggregationFunc"]),
                                                label: "Field Aggregation Type",
                                            })}
                                            {filter.value.aggregationFunc !== "None" &&
                                                AggregationFieldSelect({
                                                    filter,
                                                    field: form.field(["aggregationField"]),
                                                })}
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    ),
                })}

                {filter.value &&
                    Expandable({
                        label: "Options",
                        render: () => FilterOptions({filter, form, tileType}),
                    })}

                {Expandable({
                    label: "Title",
                    render: () => (
                        <div className="local-filter-title-78v">
                            {TextInput({
                                label: "Filter Title",
                                ...ffToTextInput(form.field(["label"])),
                            })}
                        </div>
                    ),
                })}

                <div className="control-btns">
                    <div className="button">
                        <Button
                            size="small"
                            disabled={!form.looksValid || equalDeep(initFilterState.value, filter.value)}
                            className="save-apply-btn"
                            onClick={() => form.submit(!initFilter)}
                        >
                            Save & Apply
                        </Button>
                    </div>

                    {filter.value?.id ? (
                        <div className="button">
                            <Button size="small" btnType="danger" className="delete-btn" onClick={onDelete}>
                                Delete Filter
                            </Button>
                        </div>
                    ) : (
                        <div className="button">
                            <Button
                                btnType="border"
                                size="small"
                                className="cancel-btn"
                                onClick={async () => {
                                    const res = await confirmLeaveDialog.show({});
                                    res && onCancel();
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    )}
                </div>

                <div
                    className={cx("override", {
                        active: editFieldOverride.value,
                    })}
                >
                    {cs(
                        ({}, next) =>
                            SuspendUpdate({
                                active: !editFieldOverride.value,
                                next,
                            }),
                        () =>
                            ConfigFieldOverride({
                                label: editFieldOverride.value?.label,
                                state: {
                                    value: editFieldOverride.value ? filter.value.columns.find((c) => c.modelColumnID == editFieldOverride.value.modelColumnID) : {},
                                    onChange: (val) =>
                                        filter.change((filter) => ({
                                            ...filter,
                                            columns: filter.columns.map((col) => (col.modelColumnID == editFieldOverride.value.modelColumnID ? val : col)),
                                        })),
                                },
                                onClose: () => editFieldOverride.onChange(null),
                            })
                    )}
                </div>
            </div>
        )
    );
